import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { PORTFOLIO } from '../mock';
import { Play, X } from 'lucide-react';

const PortfolioGrid = ({ limit, items: custom, cols = 3 }) => {
  const source = custom || PORTFOLIO;
  const items = limit ? source.slice(0, limit) : source;
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => e.key === 'Escape' && setActive(null);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [active]);

  return (
    <>
      <div className={`grid grid-cols-1 sm:grid-cols-2 ${cols === 3 ? 'lg:grid-cols-3' : ''} gap-4`}>
        {items.map((p) => (
          <button
            key={p.id}
            onClick={() => setActive(p)}
            className="card-hover group relative overflow-hidden rounded-xl aspect-[4/3] bg-[#111114] border border-white/5 text-left"
          >
            <img
              src={p.thumb}
              alt={`${p.title}, video content by Yellow, marketing agency Liverpool`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0d] via-transparent to-transparent opacity-70"></div>
            <div className="absolute top-4 left-4">
              <span className="text-[10px] uppercase tracking-widest text-[#F5CD1B] bg-[#0b0b0d]/70 px-2 py-1 rounded-md border border-[#F5CD1B]/20">
                {p.category}
              </span>
            </div>
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="w-14 h-14 rounded-full bg-[#F5CD1B] flex items-center justify-center">
                <Play size={20} className="text-[#0b0b0d] ml-1" fill="currentColor" />
              </div>
            </div>
            <div className="absolute bottom-4 left-4 right-4">
              <h4 className="font-display text-xl font-bold text-white">{p.title}</h4>
              <p className="text-white/60 text-xs mt-1">{p.client}</p>
            </div>
          </button>
        ))}
      </div>

      {active && createPortal(
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <button data-testid="video-lightbox-close" aria-label="Close video" className="absolute top-6 right-6 text-white p-2 hover:text-[#F5CD1B]" onClick={() => setActive(null)}>
            <X size={28} />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <div
              className="aspect-video rounded-xl overflow-hidden bg-black relative bg-cover bg-center"
              style={{ backgroundImage: active.thumb ? `url(${active.thumb})` : undefined }}
            >
              <iframe
                className="w-full h-full relative"
                src={`https://www.youtube.com/embed/${active.videoId || 'GPwWTT5rdro'}?autoplay=1&rel=0`}
                title={active.title}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
            <div className="mt-4 flex items-start justify-between gap-4 text-white">
              <div>
                <p className="section-label">{active.category}</p>
                <h3 className="font-display text-2xl font-bold mt-1">{active.title}</h3>
                <p className="text-white/60 text-sm mt-1">Client: {active.client}</p>
              </div>
              {active.videoId && (
                <a
                  href={`https://www.youtube.com/watch?v=${active.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-yellow inline-flex items-center gap-2 px-5 py-3 rounded-md uppercase text-xs whitespace-nowrap"
                >
                  Watch on YouTube <Play size={14} fill="currentColor" />
                </a>
              )}
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default PortfolioGrid;
